"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var FeedbackMobile_1 = require("./FeedbackMobile");
var utils_1 = require("../../../utils/utils");
var Feedback = /** @class */ (function (_super) {
    __extends(Feedback, _super);
    function Feedback(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isMobile: /Android|webOS|iPhone|iPod|iPad|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
        };
        _this.onWindowResize = _this.onWindowResize.bind(_this);
        return _this;
    }
    Feedback.prototype.onWindowResize = function (e) {
        this.setState(function () { return ({ isMobile: /Android|webOS|iPhone|iPod|iPad|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) }); });
    };
    Feedback.prototype.componentDidMount = function () {
        this.setState(function () { return ({ isMobile: /Android|webOS|iPhone|iPod|iPad|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) }); });
        window.addEventListener('resize', this.onWindowResize);
    };
    Feedback.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.onWindowResize);
    };
    Feedback.prototype.render = function () {
        return ((!this.state.isMobile) ?
            null :
            React.createElement(FeedbackMobile_1.default, __assign({ testId: utils_1.default(this.props.testId, 'FeedbackMobile') }, this.props)));
    };
    return Feedback;
}(React.Component));
exports.default = Feedback;
//# sourceMappingURL=Feedback.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/panels/Feedback/Feedback.js
// module id = 1395
// module chunks = 8